import Layout from "./Layout";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { t } from "i18next";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import moment from "moment";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";
import { isEmpty } from "lodash";
import { isMobile } from "react-device-detect";
const Promotion = () => {
  const [show, setShow] = useState({});
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const getFilteredOfferList = (count, list) => {
    const depositKeysToRemove = [
      "OnFirstDeposit",
      "OnSecondDeposit",
      "OnThirdDeposit",
      "OneFourthDeposit",
    ];

    const keysToRemove = depositKeysToRemove.slice(0, count);
    return list.filter((offer) => !keysToRemove.includes(offer.offerOn));
  };

  const getData = async () => {
    const { status, data } = await apiGet(apiPath.getPromotional);
    if (status == 200) {
      if (data?.success) {
        let updated = getFilteredOfferList(
          profileData?.userDepositCount || 0,
          data?.results?.offerList,
        );
        setData(updated);
      }
    }
  };
  useEffect(() => {
    getData();
  }, [profileData]);
  function getTimeDifferenceString(currentTime, endTime) {
    const now = moment(currentTime);
    const end = moment(endTime);

    if (end.isBefore(now)) {
      return "Ended";
    }

    const duration = moment.duration(end.diff(now));
    const days = Math.floor(duration.asDays());
    const hours = duration.hours();

    return `End in ${days} days ${hours} hours`;
  }
  return (
    <Layout>
      <div
        style={{ background: "white" }}
        className={!isMobile ? "padding-desktop-promotion" : ""}
      >
        <div className="row hidden-md-and-up" style={{ margin: "0px" }}>
          <div className="mobile-header text-center col col-12">
            {t("Promotion")}
          </div>
        </div>
        <div
          className="bonus-category-menu justify-space-around hidden-sm-and-down mb-2 v-card v-sheet theme--light"
          style={{ "box-shadow": "none" }}
        >
          <div className="row promotion-menu px-2 no-gutters">
            <button
              type="button"
              className="my-2 px-3 py-2 page-promotion-button v-btn v-btn--text theme--light v-size--default conditional-styles"
              style={{ height: "auto" }}
            >
              <span className="v-btn__content">
                <div className="row no-gutters">
                  <div className="px-0 text-center col col-12">
                    <label className="bonus-category-menu-title px-2">
                      {t("All")}
                    </label>
                  </div>
                </div>
              </span>
            </button>
          </div>
        </div>
        <div className="row d-flex mt-0 pt-0 align-end justify-space-around">
          <div className={`col-md-12 col ${!isMobile ? "pl-0 pr-0 pt-0" : ""}`}>
            <div
              className="promotion-card-container v-card v-sheet theme--light"
              style={{ "box-shadow": "none" }}
            >
              <div className="v-card__text">
                <div className="row align-center">
                  {data?.map((res) => {
                    return (
                      <div className="pa-3 col-md-6 col-lg-6 col-12">
                        <div
                          className={`v-card v-sheet theme--light promotion-box ${
                            !isMobile ? "pa-6" : ""
                          }`}
                          style={{ "box-shadow": "none" }}
                        >
                          <div className="v-image v-responsive promotion-image-box hidden-md-and-down theme--light">
                            <div
                              className="v-responsive__sizer"
                              style={{ "padding-bottom": "37.0748%" }}
                            />
                            <div
                              className="v-image__image v-image__image--preload v-image__image--contain"
                              style={{
                                "background-image": `url(${process.env.REACT_APP_API_BASE_URL}${res?.offerImage})`,
                                "background-position": "center center",
                              }}
                            />
                            <div className="v-responsive__content" />
                          </div>
                          <div className="v-image v-responsive promotion-image-box hidden-lg-and-up theme--light">
                            <div
                              className="v-responsive__sizer"
                              style={{ "padding-bottom": "37.0748%" }}
                            />
                            <div
                              className="v-image__image v-image__image--contain"
                              style={{
                                "background-image": `url(${process.env.REACT_APP_API_BASE_URL}${res?.offerImage})`,
                                "background-position": "center center",
                              }}
                            />
                            <div className="v-responsive__content" />
                          </div>
                          <div className="row promotion-box-row no-gutters">
                            <div className="col-12 col">
                              <div className="row promotion-desc-box no-gutters">
                                <div className="col col-12">
                                  <p className="font-weight-bold promotion-desc-title mb-1">
                                    {res?.title}
                                  </p>
                                  <p className="d-block text-truncate promotion-menu-desc mb-1">
                                    {res?.description}
                                  </p>
                                </div>
                                <div
                                  className="col-md-3 col-6"
                                  style={{
                                    "-ms-flex-item-align": "flex-end",
                                    "align-self": "flex-end",
                                    "padding-right": "5px",
                                  }}
                                >
                                  <button
                                    type="button"
                                    className="primary-button pa-1 font-weight-bold mobile-detail-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                    style={{ height: "auto" }}
                                  >
                                    <span className="v-btn__content">
                                      {t("ReadMore")}
                                    </span>
                                  </button>
                                </div>
                                {res?.category == "Deposit" && (
                                  <div
                                    onClick={() =>
                                      navigate(
                                        isEmpty(user)
                                          ? "/register"
                                          : `/bank/deposit/${res?._id}`,
                                      )
                                    }
                                    className="col-md-3 col-6"
                                    style={{
                                      "-ms-flex-item-align": "flex-end",
                                      "align-self": "flex-end",
                                      "padding-left": "5px",
                                    }}
                                  >
                                    <button
                                      type="button"
                                      className={`${
                                        isMobile
                                          ? "full-width font-weight-bold pa-1 buttonPrimary primary-button theme--light mobile-apply-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                          : "full-width pa-2 primary-button theme--light mobile-apply-btn v-btn v-btn--is-elevated v-btn--has-bg theme--light v-size--default"
                                      }`}
                                      style={{ height: "auto" }}
                                    >
                                      <span className="v-btn__content">
                                        {isEmpty(user)
                                          ? t("JoinNow")
                                          : t("Deposit")}
                                      </span>
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Promotion;
